import { database } from "firebase/app";
import { InferType, object, string } from "yup";

import recordTemplate from "./recordTemplate";
import { IUser } from "../types/auth/IUser";
import { ROOT_FOLDER } from "../store/modules/library/constants";

enum Message {
  userRequired = "userRequired",
  folderRequired = "folderRequired",
  databaseId = "databaseId",
}

const validationSchema = object({
  user: object<IUser>().required(Message.userRequired),
  activeFolder: string().required(Message.folderRequired),
});

type ValidData = InferType<typeof validationSchema>;

const createArg = ({ user, activeFolder }: ValidData): [IUser, string] => {
  const folderId = activeFolder === ROOT_FOLDER
    ? user.uid
    : activeFolder;

  return ([user, folderId]);
};

const createRecord = (user: IUser, folderId: string) => {
  const id = database().ref().child("books").push().key;

  if (!id) throw Error(Message.databaseId);

  const record = {
    ...recordTemplate,
    bookType: "TXT",
    addedBy: user.uid,
  };

  const updates = {
    [`/books/${id}`]: { ...record, text: "", },
    [`/folders/${folderId}/books/${id}`]: record,
  };

  return database().ref().update(updates).then(() => ({ id, ...record, }));
};

export {
  createArg,
  createRecord,
  Message,
  validationSchema,
};
